var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.materials,
          columns: _vm.columns_materials,
          pagination: _vm.server_pagination,
          selection: "multiple",
          selected: _vm.materials_selected,
          loading: _vm.loading,
          "row-key": "material_id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          "update:selected": function($event) {
            _vm.materials_selected = $event
          },
          request: _vm.requestMaterials
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _vm.materials_selected.length > 0
                  ? _c("q-btn", {
                      staticClass: "q-mr-sm",
                      attrs: {
                        color: "negative",
                        icon: "fas fa-ban",
                        label: _vm.$t("remove"),
                        disable: _vm.disableMaterials
                      },
                      on: { click: _vm.removeMaterials }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("add_inputs"),
                    disable: _vm.disableMaterials
                  },
                  on: { click: _vm.showAddMaterials }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-th",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          "indeterminate-value": "some",
                          disable: _vm.disableMaterials
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t(col.label)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c(
                    "q-td",
                    { attrs: { "auto-width": "" } },
                    [
                      _c("q-checkbox", {
                        attrs: {
                          color: "primary",
                          disable: _vm.disableMaterials
                        },
                        model: {
                          value: props.selected,
                          callback: function($$v) {
                            _vm.$set(props, "selected", $$v)
                          },
                          expression: "props.selected"
                        }
                      })
                    ],
                    1
                  ),
                  _c("q-td", { key: "material_id", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.material_id) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "material", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.material) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "qty_material", attrs: { props: props } },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "number",
                          error:
                            _vm.$v.materials.$each[props.row.__index]
                              .qty_material.$error,
                          disable: _vm.disableMaterials
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkMaterials()
                          },
                          input: function($event) {
                            _vm.$v.materials.$each[props.row.__index]
                              .qty_material.$touch
                          }
                        },
                        model: {
                          value: props.row.qty_material,
                          callback: function($$v) {
                            _vm.$set(props.row, "qty_material", $$v)
                          },
                          expression: "props.row.qty_material"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "unit_material_cost", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                $ " +
                          _vm._s(props.row.unit_material_cost) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "total_material_cost", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                $ " +
                          _vm._s(
                            (
                              props.row.qty_material *
                              props.row.unit_material_cost
                            ).toFixed(2)
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "actions",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c("q-btn", {
                        attrs: {
                          round: "",
                          flat: "",
                          icon: "fas fa-trash",
                          color: "negative",
                          disable: _vm.disableMaterials
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeMaterial(props)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_materials,
            callback: function($$v) {
              _vm.show_materials = $$v
            },
            expression: "show_materials"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_materials = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("inputs")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.materials_list,
                      columns: _vm.columns_materials,
                      pagination: _vm.materials_pagination,
                      filter: _vm.filter_materials,
                      loading: _vm.loading,
                      selection: "multiple",
                      selected: _vm.materials_selected,
                      "row-key": "material_id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.materials_pagination = $event
                      },
                      request: _vm.requestNewMaterials,
                      "update:selected": function($event) {
                        _vm.materials_selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "fas fa-search",
                                placeholder: _vm.$t("search"),
                                "float-label": _vm.$t("search"),
                                debounce: 600
                              },
                              model: {
                                value: _vm.filter_materials,
                                callback: function($$v) {
                                  _vm.filter_materials = $$v
                                },
                                expression: "filter_materials"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _vm.materials_selected.length > 0
                              ? _c("q-btn", {
                                  attrs: {
                                    color: "positive",
                                    icon: "far fa-save",
                                    label: _vm.$t("add")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addMaterials()
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { color: "primary" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "material_id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.material_id) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "material", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(props.row.material) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "qty_material",
                                  attrs: { props: props }
                                },
                                [
                                  _c("q-input", {
                                    attrs: { type: "number" },
                                    model: {
                                      value: props.row.qty_material,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "qty_material", $$v)
                                      },
                                      expression: "props.row.qty_material"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "unit_material_cost",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            $ " +
                                      _vm._s(
                                        props.row.unit_material_cost.toFixed(2)
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "total_material_cost",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                            $ " +
                                      _vm._s(
                                        (
                                          props.row.qty_material *
                                          props.row.unit_material_cost
                                        ).toFixed(2)
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }